import { useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Button, Form, Input, Card, Alert } from "antd";
import { useDispatch } from "react-redux";

import classes from "./LoginCard.module.scss";
import { validateMessages } from "../../utils/validation";
import { loginAPI } from "../../API/endpoints/auth";
import { sliceActions as authActions } from "../../store/auth-slice";
import { decodeToken } from "../../utils/auth";
import ReCaptcha from "./ReCaptcha";

export default function LoginCard() {
  const [error, setError] = useState();
  const [captchaValue, setCaptchaValue] = useState(null);
  const [isRecaptchaRequired, setIsRecaptchaRequired] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (values) => {
    try {
      if (isRecaptchaRequired && !captchaValue) {
        return;
      }
      const { captcha, ...formData } = values;
      const response = await loginAPI(formData, captchaValue);
      const { token: accessToken, refreshToken } = response.data;
      dispatch(authActions.setAccessToken(accessToken));
      const decodedToken = decodeToken(accessToken);
      localStorage.setItem("refresh", refreshToken);
      const isAdmin = decodedToken.roles?.includes("ROLE_ADMIN");
      if (isAdmin) {
        setError("User not found");
        return;
      }
      navigate("/", { state: { from: location }, replace: true });
    } catch (error) {
      if (error.status === 403) {
        setIsRecaptchaRequired((prev) => {
          if (!prev) {
            setError(
              "You've tried to sign in with incorrect password or email too many times"
            );
          }
          return true;
        });
      } else {
        setIsRecaptchaRequired(false);
        setError(error?.response?.data?.message || "Something went wrong");
      }
      setCaptchaValue(null);
    }
  };

  return (
    <Card title="LOGIN" className={classes.card}>
      {error && <Alert message={error} type="error" />}
      <Form
        name="basic"
        onFinish={handleSubmit}
        autoComplete="off"
        layout="vertical"
        validateMessages={validateMessages}
        size="large"
      >
        <Form.Item
          name="email"
          label="Email"
          rules={[{ required: "true", type: "email" }]}
        >
          <Input placeholder="Enter your email" />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input.Password placeholder="Enter your password" />
        </Form.Item>

        {isRecaptchaRequired && (
          <ReCaptcha value={captchaValue} onChange={setCaptchaValue} />
        )}

        <div className={classes.forgot}>
          <Link to={"/auth/forgot-password"} className={classes.clickableSpan}>
            Forgot password?
          </Link>
        </div>

        <Form.Item className={classes.submitButton}>
          <Button type="primary" htmlType="submit" block>
            Login
          </Button>
        </Form.Item>

        <div className={classes.signup}>
          <span>Don't have an account?</span>
          <Link to={"/auth/register"} className={classes.clickableSpan}>
            Sign up
          </Link>
        </div>
      </Form>
    </Card>
  );
}
